<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>{{ action == "create" ? "Create" : "Edit" }} Product</h2>
    </div>
    <div class="form-spacing"></div>
    <v-divider></v-divider>
    <div class="form-spacing"></div>
    <v-form ref="form">
      <div
        :style="{
          marginLeft: generalSpacingLeftRight + '%',
          marginRight: generalSpacingLeftRight + '%',
        }"
      >
        <v-card outlined>
          <v-card-title>Basic Information</v-card-title>
          <v-card-subtitle>Please fill in all of the details</v-card-subtitle>
          <div style="padding: 20px">
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Product Name"
                v-model="selected_product_name"
                placeholder="e.g 100 Plus"
                :rules="[
                  () => !!selected_product_name || 'Product name is required',
                  () =>
                    selected_product_name.length >= 10 ||
                    'Product name is too short',
                ]"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextArea
                :is_required="true"
                title="Product Description"
                v-model="selected_product_description"
                :rules="[
                  () =>
                    !!selected_product_description ||
                    'Product description is required',
                  () =>
                    selected_product_description.length >= 50 ||
                    'Product description is too short',
                ]"
              ></RowTextArea>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowComboBox
                :is_required="true"
                title="Product Category"
                v-model="selected_product_category"
                :items="product_category_list"
                :multiple="true"
                :rules="[
                  () =>
                    selected_product_category.length > 0 ||
                    'At least one product category is needed',
                ]"
              ></RowComboBox>
            </div>
          </div>
        </v-card>
      </div>
      <div class="form-spacing"></div>
      <div
        :style="{
          marginLeft: generalSpacingLeftRight + '%',
          marginRight: generalSpacingLeftRight + '%',
        }"
      >
        <v-card outlined>
          <v-card-title>Sales Information</v-card-title>
          <v-card-subtitle>Please fill in all of the details</v-card-subtitle>
          <div style="padding: 20px">
            <template v-if="!is_variation_mode">
              <div style="margin-top: 10px; margin-bottom: 10px">
                <RowCurrencyTextField
                  :is_required="true"
                  title="Selling Price (RM)"
                  v-model="selected_product_price"
                  :rules="[
                    () =>
                      Number(selected_product_price) > 0 ||
                      'Product selling price must be greater than 0',
                  ]"
                ></RowCurrencyTextField>
              </div>
              <div style="margin-top: 10px; margin-bottom: 10px">
                <RowTextField
                  :is_required="true"
                  title="Inventory"
                  v-model="selected_product_inventory"
                  @keypress="only_for_number"
                  :rules="[
                    () =>
                      !!selected_product_inventory || 'Inventory is required',
                    () =>
                      Number(selected_product_inventory) <= 999999 ||
                      'Inventory must be lesser than 999999',
                  ]"
                ></RowTextField>
              </div>
            </template>
            <ProductVariationForm
              :variation1_name="variation1"
              :variation1_options="variation1_options"
              @enable_variation="enable_variation"
              @disable_variation="disable_variation"
              @input_variation1="update_variation1"
              @input_variation1_option="update_variation1_option"
              @add_variation1="add_variation1"
              @delete_variation1_option="delete_variation1_option"
              :variation2_name="variation2"
              :variation2_options="variation2_options"
              @enable_variation2="enable_variation2"
              @disable_variation2="disable_variation2"
              @input_variation2="update_variation2"
              @input_variation2_option="update_variation2_option"
              @add_variation2="add_variation2"
              @delete_variation2_option="delete_variation2_option"
            ></ProductVariationForm>
          </div>
        </v-card>
      </div>
    </v-form>
  </div>
</template>

<script>
import RowComboBox from "../components/RowComboBox.vue";
import RowTextField from "../components/RowTextField.vue";
import RowCurrencyTextField from "../components/RowCurrencyTextField.vue";
import RowAutocompleteField from "../components/RowAutocompleteField.vue";
import RowTextArea from "../components/RowTextArea.vue";
import ProductVariationForm from "../components/ProductVariationForm.vue";

export default {
  components: {
    RowComboBox,
    RowTextField,
    RowCurrencyTextField,
    RowAutocompleteField,
    RowTextArea,
    ProductVariationForm,
  },
  data: function () {
    return {
      action: this.$route.params.id == "create" ? "create" : "edit",
      selected_product_id: "",
      selected_product_name: "",
      selected_product_description: "",
      selected_product_inventory: "",
      selected_product_category: [],
      selected_product_price: null,
      variation1: "",
      variation1_options: [{ name: "", price: 0, inventory: 0, sku: "" }],
      variation2: "",
      variation2_options: [{ name: "", price: 0, inventory: 0, sku: "" }],
      is_variation_mode: false,
      is_variation2_mode: false,
      product_category_list: [],
    };
  },
  methods: {
    load_info() {},
    load_product_category() {
      this.send_http_request("loadAllProductCategory", {})
        .then((response) => {
          if (response.data.status == "OK") {
            this.product_category_list = response.data.result;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    enable_variation() {
      this.is_variation_mode = true;
    },
    disable_variation() {
      this.is_variation_mode = false;
      this.variation1 = "";
      this.variation1_options = [{ name: "", price: 0, inventory: 0, sku: "" }];
      this.variation2 = "";
      this.variation2_options = [{ name: "", price: 0, inventory: 0, sku: "" }];
    },
    update_variation1(value) {
      this.variation1 = value;
    },
    update_variation1_option(value) {
      // value.value, value.index
      // value.value.name, value.value.price, value.value.inventory, value.value.sku
      this.variation1_options[value.index] = value.value;
    },
    add_variation1() {
      this.variation1_options.push([
        { name: "", price: 0, inventory: 0, sku: "" },
      ]);
    },
    delete_variation1_option(index) {
      this.variation1_options.splice(index, 1);
    },
    enable_variation2() {
      this.is_variation2_mode = true;
    },
    disable_variation2() {
      this.is_variation2_mode = false;
      this.variation2 = "";
      this.variation2_options = [{ name: "", price: 0, inventory: 0, sku: "" }];
    },
    update_variation2(value) {
      this.variation2 = value;
    },
    update_variation2_option(value) {
      // value.value, value.index
      // value.value.name, value.value.price, value.value.inventory, value.value.sku
      this.variation2_options[value.index] = value.value;
    },
    add_variation2() {
      this.variation2_options.push([
        { name: "", price: 0, inventory: 0, sku: "" },
      ]);
    },
    delete_variation2_option(index) {
      this.variation2_options.splice(index, 1);
    },
  },
  mounted() {
    this.load_product_category();
    if (this.action != "create") {
      this.selected_product_id = this.$route.params.id;
      this.load_info();
    }
  },
  created() {
    // Update store
    var payload = { headerType: "needHeader", currentPage: "ProductScreen" };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
  },
};
</script>

<style scoped>
.form-spacing {
  margin-top: 25px;
  margin-bottom: 25px;
}
</style>